import React from "react";
import InventarioBase, { InventarioPageConfig } from "./InventarioBase";

const config: InventarioPageConfig = {
  documentTitle: "Stock - Inventario inicial | Saas",
  breadcrumbTitle: "Inventario inicial",
  breadcrumbSection: "Stock",
  conceptoEditable: false,
  conceptoPredeterminado: "Inventario inicial",
  contextLabel: "Inventario inicial",
  contextPluralLabel: "Inventarios iniciales",
  apiPath: "/api/stock/inventarios/inicial",
};

const InventarioInicialPage: React.FC = () => <InventarioBase config={config} />;

export default InventarioInicialPage;
